<template>
  <div
    class="alert bg-[#3F4D5A] shadow-lg px-7 mobile-width xl:!w-fit fixed z-[1000] -top-20 xl:top-[unset] xl:-bottom-20 left-1/2 -translate-x-1/2 transition-all duration-300 ease-in"
    :class="{ 'top-4 xl:top-[unset] xl:bottom-4': show }"
  >
    <div>
      <img v-if="type === 'check'" src="@/assets/images/icon/ico_alert_check.svg" alt="" />
      <img v-if="type === 'warning'" src="@/assets/images/icon/ico_alert_warning.svg" alt="" />
      <span class="text-sm font-bold text-white xl:text-base">{{ text }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlertComponent',
  props: {
    type: { type: String, default: '' },
    text: { type: String, default: 'alert' },
  },
  data() {
    return {
      show: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.show = true;
    }, 100);
    setTimeout(() => {
      this.show = false;
    }, 4000);
    setTimeout(() => {
      this.$el.remove();
      this.$destroy();
    }, 5000);
  },
};
</script>

<style lang="scss">
.mobile-width {
  width: calc(100% - 40px);
}
</style>
